<template>
  <div id="app" class="wrapper">
    <!-- <Push disableOutsideClick> -->
    <v-navigation-drawer
      temporary
      hide-overlay
      v-model="drawer"
      width="300"
      fixed
      color="rgb(240,240,240)"
      floating
    >
      <div class="d-flex flex-column align-center">
        <img src="@/assets/dn2me.svg" alt />
      </div>

      <ul>
        <li @click="goHome">
          <p :class="{actived: this.$route.name === 'home'}">Κεντρική σελίδα</p>
        </li>
        <li @click="goProfile">
          <p :class="{actived: this.$route.name === 'profile' || this.$route.name === 'editProfile'}">Προφίλ</p>
        </li>
        <li @click="goFaq">
          <p :class="{actived: this.$route.name === 'faq'}">Συχνές Ερωτήσεις</p>
        </li>

        <li @click="goTerms">
          <p :class="{actived: this.$route.name === 'terms'}">Όροι & Προϋποθέσεις</p>
        </li>

        <li @click="goInfo">
          <p :class="{actived: this.$route.name === 'info'}">Σχετικά</p>
        </li>

        <!-- <li @click="$router.push('/terms').then().catch(err => {})">
          <p :class="{actived: this.$route.name === 'terms'}">Terms & Conditions</p>
        </li>
        <li>
          <p>About</p>
        </li>-->
        <li style="position: absolute; bottom: 0;" class="mt-12">
          <p style="font-size:13px;">
            <a
              href="mailto:support@dn2me.com?subject=Διαγραφή Λογαριασμού"
              style="text-decoration:none; color:red"
            >Διαγραφή Λογαριασμού</a>
          </p>

          <p style="font-size:13px; color:rgb(74,74,74)">Version: 1.0.0</p>
        </li>
        <li class="mt-12" @click="logout">
          <p>Αποσύνδεση</p>
        </li>
      </ul>
    </v-navigation-drawer>

    <!-- </Push> -->

    <v-icon
      @click="drawer = true"
      x-large
      v-if="!($route.name ==='room')"
      :style="($route.name !== 'profile') ? 'position:fixed; top:10px; left:10px; cursor: pointer; background-color:WHITE; border-radius:50%; z-index:2;' : 'position:fixed; top:10px; left:10px; cursor: pointer; color:white; border-radius:50%; z-index:2;'"
    >mdi-menu</v-icon>
    <router-view></router-view>

    <v-overlay v-model="loggingOut"></v-overlay>
  </div>
</template>

<script>
import { Push } from "vue-burger-menu";
export default {
  components: {
    Push
  },
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    goHome() {
      this.drawer = false;
      this.$router
        .push("/home")
        .then()
        .catch(err => {});
    },
    goFaq() {
      this.drawer = false;
      this.$router
        .push("/faq")
        .then()
        .catch(err => {});
    },
    goProfile() {
      this.drawer = false;
      this.$router
        .push("/profile")
        .then()
        .catch(err => {});
    },
    goTerms() {
      this.drawer = false;
      this.$router
        .push("/terms")
        .then()
        .catch(err => {});
    },
    goInfo() {
      this.drawer = false;
      this.$router
        .push("/info")
        .then()
        .catch(err => {});
    },
    logout() {
      this.drawer = false;
      this.$store
        .dispatch("logout")
        .then(res => {
          this.$router.push("/");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    loggingOut() {
      return this.$store.state.loggingOut;
    }
  }
};
</script>


<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin-top: 50px;
}

li {
  cursor: pointer;
  p {
    font-size: 20px;
    &:active {
      font-weight: bold;
    }
  }
}

.actived {
  font-weight: bold;
}

//ready
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
  cursor: pointer;
}
.bm-burger-bars {
  background-color: #373a47;
}
.line-style {
  position: absolute;
  height: 20%;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  background-color: rgb(63, 63, 65); /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 20px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
</style>
